import React from 'react';

const AdminCompanyContext = React.createContext({
    companyId: null,
    companyData: null,
});

export function AdminCompanyProvider({ companyId, companyData, children }) {
    const value = React.useMemo(
        () => ({ companyId: companyId ?? null, companyData: companyData ?? null }),
        [companyId, companyData],
    );

    return (
        <AdminCompanyContext.Provider value={value}>
            {children}
        </AdminCompanyContext.Provider>
    );
}

export function useAdminCompany() {
    return React.useContext(AdminCompanyContext);
}
